const mapsBaseURL = "https://www.google.com/maps/dir/"

export default function (origin: string, destination: string) {
    const urlParams = new URLSearchParams({
        api: "1",
        destination: destination ?? undefined,
        origin: origin
    }).toString()

    const url = new URL(mapsBaseURL);
    url.search = urlParams;

    return url.toString();
}
